import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
@Directive({
    selector: 'input[virtualKeyboardFooter]',
})
export class VirtualKeyboardFooterDirective implements OnInit {
    footer: any;
    originalContentHeight: any;
    constructor() {
        console.log('whadup biyatch:')
    }
    ngOnInit() {
        this.footer = document.querySelector('.modal-footer');
        this.originalContentHeight = document.body.clientHeight;
        console.log('whadup biyatch: x2', this.originalContentHeight)
    }

    @HostListener('focus', ['$event.target'])
    onFocus(target) {
    const keyboardHeight = window.innerHeight - document.body.clientHeight;
        document.body.style.height = `${this.originalContentHeight + keyboardHeight}px`;
        console.log('keyboardHeight:', keyboardHeight)
    }

    @HostListener('blur', ['$event.target'])
    onBlur(target) {
      document.body.style.height = `${this.originalContentHeight}px`;
        console.log(document.body.style.height)
    }


}